import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { SharedModule } from "../../shared.module";
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-user-details',
  standalone: false,
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss'
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  userForm!: FormGroup;
  cols: any[] = [
    // { field: 'dragg', header: '' },
    { field: 'rankName', header: 'Rank Name', filterType: 'text' },
    { field: 'first_name', header: 'First Name', filterType: 'text' },
    { field: 'last_name', header: 'Last Name', filterType: 'text' },
    { field: 'loginname', header: 'Login Name', filterType: 'text' },
    { field: 'hrcdf_designation', header: 'Designation', filterType: 'text' },
    // { field: 'unit.name', header: 'Unit', filterType: 'text' },
  ];
  tableTitle = 'User Details';
  showAddUserDialog: boolean = false;
  showEditUserDialog: boolean = false;
  showDeleteUserDialog: boolean = false;
  userData: any[] = [];
  selectedUser: any;
  adUser = false;
  phone = '';
  unitList: any;
  showPassword: boolean = false;
  usertypeList: any;
  private mySubscription = new Subscription();

  constructor(
    private apiService: ApiService, private fb: FormBuilder, private messageService: MessageService, private http: HttpClient, private permissionService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      loginname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      first_name: ['', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]],
      last_name: ['', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]],
      password: ['' ,  [
    Validators.required,
    Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-={}\\[\\]:;"\'<>,.?/\\\\|]).{8,}$'),
  ],],
      unit: [''],
      userType: [''],
      // is_active: [false],
      // staff: [false],
      // admin: [false],
      // status: [1, Validators.required],
      ad_user: [false],
      phone: [''],
      hrcdf_designation: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      rankCode: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      rankName: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
    });

    this.getUserData();
  }
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  addUser() {
    this.userForm.reset();
    this.userForm.enable()
    this.userForm.get('password')?.enable();
    this.showAddUserDialog = true;
    this.getUnit()
  }
  getUnit() {
    const sub = this.apiService.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
      this.getUserType();
    })
    this.mySubscription.add(sub)
  }
  getUserType() {
    const allowedTypes = ['CADMIN', 'DADMIN', 'GUEST' , 'PDIRECTORATE'];
    const sub = this.apiService.getAPI('/access/user-roles/').subscribe((res: any) => {
      let resp = res.data
      this.usertypeList = resp.filter(userType => allowedTypes.includes(userType.code));
      // this.usertypeList = resp;
    })
    this.mySubscription.add(sub)
  }
  submitUserDetailsForm() {
    if (this.userForm.valid) {
      // const payload = this.userForm.value;
      let unit = this.userForm.get('unit').value
      let payload = {
        loginname: this.userForm.get('loginname').value,
        email: this.userForm.get('email').value,
        first_name: this.userForm.get('first_name').value,
        password: this.userForm.get('password').value,
        last_name: this.userForm.get('last_name').value,
        unit: parseInt(unit),
        is_active: true,
        staff: true,
        admin: false,
        status: 1,
        ad_user: this.userForm.get('ad_user')?.value ?? false,
        hrcdf_designation: this.userForm.get('hrcdf_designation').value,
        rankCode: this.userForm.get('rankCode').value,
        rankName: this.userForm.get('rankName').value,
        user_role: this.userForm.get('userType').value
      }


      const sub = this.apiService.postAPI('/account/users/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'New user added'
          });
          this.showAddUserDialog = false;
          this.userForm.reset();
          // this.userData.push(res.data)
          this.userData = [...this.userData, res.data];
        }
      });
      this.mySubscription.add(sub)

    }
  }
  totalRecords: number = 0;
  getUserData(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/account/users/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.apiService.getAPI(url).subscribe((res: any) => {
      this.userData = res.results.data;
      this.totalRecords = res.count || 0
    });
    this.mySubscription.add(sub)
  }

  viewMode = false;
viewSystem(user: any) {
  this.viewMode = true;
   if (user && user.id) {
    this.showEditUserDialog = true;
    this.selectedUser = user;
    this.getUnit();
    this.userForm.patchValue({
      ad_user: user.ad_user,
      first_name: user.first_name,
      last_name: user.last_name,
      loginname: user.loginname,
      email: user.email,
      password: user.password,
      hrcdf_designation: user.hrcdf_designation,
      rankCode: user.rankCode,
      rankName: user.rankName,
      unit: user.unit.id || null,
      userType: user.user_role || null
    });
    this.userForm.disable()
    this.userForm.get('password')?.disable();
    }
}
  updateUser(user: any) {
    this.viewMode = false;
    this.userForm.enable()
    this.showEditUserDialog = true;
    this.selectedUser = user;
    this.getUnit();
    this.userForm.patchValue({
      ad_user: user.ad_user,
      first_name: user.first_name,
      last_name: user.last_name,
      loginname: user.loginname,
      email: user.email,
      password: user.password,
      hrcdf_designation: user.hrcdf_designation,
      rankCode: user.rankCode,
      rankName: user.rankName,
      unit: user.unit.id || null,
      userType: user.user_role || null
    });
    this.userForm.get('password')?.disable();
  }
  editUserDetailsForm() {
    // let unit = this.userForm.get('unit')?.value
    let unitControl = this.userForm.get('unit');
    let unitValue = unitControl?.value;
    let unit = unitValue !== null && unitValue !== undefined && unitValue !== '' ? parseInt(unitValue) : null;

    let payload = {
      // id:this.userForm.get('id').value,
      loginname: this.userForm.get('loginname').value,
      email: this.userForm.get('email').value,
      first_name: this.userForm.get('first_name').value,
      // password:this.userForm.get('password').value,
      last_name: this.userForm.get('last_name').value,
      unit: unit,
      is_active: true,
      staff: true,
      admin: false,
      status: 1,
      ad_user: this.userForm.get('ad_user')?.value ?? false,
      hrcdf_designation: this.userForm.get('hrcdf_designation').value,
      rankCode: this.userForm.get('rankCode').value,
      rankName: this.userForm.get('rankName').value,
      user_role: this.userForm.get('userType').value
    }


    const sub = this.apiService.putAPI(`/account/users/${this.selectedUser.id}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User details updated'
        });
        this.showEditUserDialog = false;
        this.userForm.reset();
        this.getUserData();
      }
    });
    this.mySubscription.add(sub)
  }
  deleteUser(user: any) {
    this.showDeleteUserDialog = true;
    this.selectedUser = user
  }
  confirmDelete() {
    const sub = this.apiService.deleteAPI(`/account/users/${this.selectedUser.id}/`).subscribe((res: any) => {
      this.showDeleteUserDialog = false;
      this.getUserData();
      // if (res) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'User deleted successfully'
      });
      this.showEditUserDialog = false;
      this.userForm.reset();
      // }
    });
    this.mySubscription.add(sub)
  }
  fetchData() {
    const url = `https://iima-api.ilizien-projects-cdf.in/api/auth/users/hrcdf?personal_number=${this.phone}`;

    this.http.get(url).subscribe({
      next: (response) => {
        // Handle your response here
      },
      error: (err) => {
        console.error('API Error:', err);
      }
    });
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/setup', 'Edit') ||
      this.permissionService.hasPrivilege('/setup', 'Delete')||
      this.permissionService.hasPrivilege('/setup', 'View');
  }
}
